import { type PropsWithChildren } from "react";
import cn from "classnames";
import styles from "./Typography.module.scss";
import IntrinsicElements = React.JSX.IntrinsicElements;

export type TypographyVariants = "h1" | "h2" | "h3" | "h4" | "title1" | "title2" | "paragraph" | "caption";

type TypographyHTMLElements = "h1" | "h2" | "h3" | "h4" | "p";

const TypographyTags: Record<TypographyVariants, TypographyHTMLElements> = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  paragraph: "p",
  caption: "p",
  title1: "h1",
  title2: "h2",
};

type ColorType = "default" | "grey" | "light" | "red";

export type TypographyProps = PropsWithChildren & {
  variant?: TypographyVariants;
  component?: keyof IntrinsicElements;
  bold?: boolean;
  italic?: boolean;
  color?: ColorType;
  className?: string;
};

export const Typography = ({
  variant = "paragraph",
  bold,
  italic,
  component,
  color = "default",
  children,
  className,
  ...props
}: TypographyProps) => {
  const safeVariant = variant || "paragraph";
  const Tag = component || TypographyTags[safeVariant];
  return (
    <Tag
      className={cn(styles.base, styles[color], className, {
        [styles[safeVariant]]: safeVariant,
        [styles.bold]: bold,
        [styles.italic]: italic,
      })}
      {...props}
    >
      {children}
    </Tag>
  );
};
